
import { MyAccountInterface } from '@central-products/interface-myaccount';

import MyAccount from './MyAccount';


export var FEATURE_NAME = '@feature/myaccount';

export var feature = {
  name: FEATURE_NAME,
  create: function create(config, dependencies, transport) {
    return new MyAccount(config, dependencies, transport);
  },
  dependsOn: ['session-manager', 'data-access-service'],
  implements: MyAccountInterface,
  role: 'my-account'
};